module.exports = __webpack_public_path__ + "img/alearn_thumb.6809fe6c.jpg";